//export const apiUrl =  'http://3.22.222.14:9000';


//export const apiUrl =  'http://localhost:9000';

export const apiUrl = 'https://www.marquisdevelopers.com/admin-panel/api';